import React, { useEffect, useState } from "react";
import { Button, Img, Text } from "components";
import { useTranslation } from "react-i18next";
import { CheckboxCustom } from "components/CheckboxCustom";
import { AddToCart } from "popups/AddToCart";
import { RepeatOrder } from "popups/RepeatOrder";
import { AddToMyOccasion } from "popups/AddToMyOccasion";
import globalRequest from "../../../utils/global/globalRequest";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../../redux/reducers/loader";
import { setSnackbar } from "../../../redux/reducers/snackbar";
import * as CUSTOM from "../../../utils/helper/custom";
import * as APIS from "../../../utils/helper/Enum";
import { getAuth } from "../../../redux/reducers/loginData";
import { AddToMyOccasionAddNew } from "popups/AddToMyOccasionAddNew";
import { changeTrigger } from "redux/reducers/trigger";
import {
  updateOrderData,
  getOrderData,
} from "../../../redux/reducers/orderData";
import styled from "styled-components";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { useAppFont } from "utils/helper/useAppFont";

const HtmlTooltip = styled(
  React.forwardRef(function HtmlTooltip(props, ref) {
    return (
      <Tooltip {...props} ref={ref} classes={{ popper: props.className }} />
    );
  })
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "transparent",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 300,
    margin: 0,
    padding: 0,
    ".MuiTooltip-arrow": {
      color: "#FFFFFF", // Arrow color
      width: "28px", // Arrow width
      height: "16px", // Arrow height
      bottom: "-8px", // Position where arrow is pointing
      left: "-9px !important", // Position where arrow is pointing
    },
  },
}));
const CartProductDetail = (props) => {
  const { orderSummary, isPopup, onClose } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const auth = useSelector(getAuth);
  const orderData = useSelector(getOrderData);
  const [AddToCartOpen, setAddToCartOpen] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponCodeError, setCouponCodeError] = useState("");
  const [customizeOpen, setCustomiseOpen] = useState(false);
  const [checkedCartItemId, setCheckedCartItemId] = useState([]);
  const [RepeatOrderOpen, setRepeatOrderOpen] = useState(false);
  const [AddToMyOccasionOpen, setAddToMyOccasionOpen] = useState(false);
  const [AddToMyOccasionAddNewOpen, setAddToMyOccasionAddNewOpen] =
    useState(false);
  const [incrementQty, setIncrementQty] = useState({
    id: 0,
    qty: 0,
    product_id: 0,
    productName: "",
    price:0,
    uomData: {},
  });
  const [updatedModiferQuantity, setUpdatedModiferQuantity] = useState([]);
  const { interClass, headingClass, interFamily, headingFamily } = useAppFont();

  const isReservationFlow = !!orderData?.isReservationFlow;
  const reservationData = orderData?.reservationData || {};
  // ─────────────────────────────────────────────────────────────────────────

  /**
   * handle repeat order
   */
  const handelRepeatOrder = () => {
    setRepeatOrderOpen(true);
    document.body.classList.add("overflow-hidden");
    document.getElementById("header-box").classList.add("relative");
  };

  /**
   * handle add to my occasion
   */
  const handelAddToMyOccasion = () => {
    setAddToMyOccasionOpen(true);
    document.body.classList.add("overflow-hidden");
    document.getElementById("header-box").classList.add("relative");
  };

  /**
   * handle add to mu occasion new
   */
  const handelAddToMyOccasionAddNew = () => {
    setAddToMyOccasionAddNewOpen(true);
    document.body.classList.add("overflow-hidden");
    document.getElementById("header-box").classList.add("relative");
  };

  /**
   * set selected cart id
   */
  const storeChekboxCartId = (newValue, isChecked) => {
    let updatedArray = [...checkedCartItemId];
    if (isChecked) {
      updatedArray.push(newValue);
    } else {
      updatedArray = updatedArray.filter((item) => item !== newValue);
    }
    setCheckedCartItemId(updatedArray);
  };

  /**
   * Apply coupon code
   */
  const applyCouponCode = async () => {
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(
        APIS?.COUPON?.APPLY,
        "get",
        {},
        {
          params: {
            coupon_code: couponCode ? couponCode.trim() : "",
            delivery_mode:
              orderData?.DeliveryModeActiveTab == 2 ? "pickup" : "delivery",
            delivery_fees: CUSTOM.setPrice(orderSummary?.delivery_fees),
          },
        },
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        dispatch(
          updateOrderData({
            ...orderData,
            couponCode: couponCode.trim(),
            couponCodeId: response?.data?.data?.id,
          })
        );
        CUSTOM.trackCouponApplied({
          coupon_code: couponCode.trim(),
        });
        setCouponCode("");
        dispatch(changeLoader(false));
        dispatch(changeTrigger("loadSummay"));
        // setTimeout(()=>{
        //   dispatch(changeTrigger("updateinlocal"));
        // },[500])
        return;
      } else {
        setCouponCodeError(response?.message);
      }
    } catch (e) {}
    dispatch(changeLoader(false));
  };

  /**
   * get modifiers
   */
  const getModifiers = async (id) => {
    try {
      let response = await globalRequest(
        `${APIS?.PRODUCTS?.GET_MODIFIER_BY_UOM_ID}/${id}`,
        "get",
        {},
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        return {
          status: "success",
          data: response?.data,
        };
      } else {
        return {
          status: "success",
          data: [],
        };
      }
    } catch (e) {
      return {
        status: "error",
        message: e?.message,
      };
    }
  };

  /**
   * get product uoms
   */
  const getProductUoms = async (id) => {
    try {
      let response = await globalRequest(
        `${APIS?.PRODUCTS?.GET_UOMS_BY_PRODUCT_ID}/${id}`,
        "get",
        {},
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        return {
          status: "success",
          data: response?.data,
        };
      } else {
        return {
          status: "success",
          data: [],
        };
      }
    } catch (e) {
      return {
        status: "error",
        message: e?.message,
      };
    }
  };

  /**
   *  check product data
   * */
  const checkProductData = async (id, qty, main_product_id) => {
    let uomData = await getProductUoms(main_product_id);
    if (uomData?.status == "error") {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: uomData?.message,
          snackbarState: "error",
        })
      );
      return "error";
    }
    if (uomData?.data?.length <= 1) {
      let modifierData = await getModifiers(uomData?.data?.[0]?.id);
      if (modifierData?.status == "error") {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: modifierData?.message,
            snackbarState: "error",
          })
        );
        return "error";
      }
      if (modifierData?.data?.length == 0) {
        decrementCount(id, qty, "add");
        return "incremented";
      }
    }
    return "open_popup";
  };

  /**
   *  add more quantity in existing item
   */
  const incrementCount = async (id, qty, productId, uomData) => {
    const data = await checkProductData(id, qty, productId);
    if (data != "open_popup") return;
    handelRepeatOrder();
    setIncrementQty({
      id: id,
      qty: qty,
      product_id: productId,
      uomData: uomData,
    });
  };

  /**
   * remove coupon code
   */
  const removeCouponCode = () => {
    dispatch(changeLoader(true));
    setTimeout(() => {
      dispatch(
        updateOrderData({ ...orderData, couponCode: "", couponCodeId: "" })
      );
      setCouponCode("");
      dispatch(changeLoader(false));
      dispatch(changeTrigger("loadSummay"));
    }, [500]);
  };

  /**
   * remove or update cart item quantity (Subtract Quantity)
   */
  const decrementCount = async (id, qtyCount, type = "subtract") => {
    dispatch(changeLoader(true));
    try {
      let inputData = {
        cart_item_id: id,
        qty: type == "subtract" ? Number(qtyCount) - 1 : Number(qtyCount) + 1,
        gaData: CUSTOM.getGACookieValues(),
      };
      let response = await globalRequest(
        APIS?.CART?.UPDATE_QTY,
        "put",
        inputData,
        {},
        true
      );
      response = response?.data;
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: response?.message,
          snackbarState: response.status == "SUCCESS" ? "success" : "error",
        })
      );
      if (response.status == "SUCCESS") {
        dispatch(changeTrigger("fetchCartCount"));
      }
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
    dispatch(changeLoader(false));
  };

  const isShowCouponCode = () => {
    if (orderData?.DeliveryModeActiveTab == 1) {
      if (orderData?.pageStep == 4) {
        return true;
      }
    } else if (orderData?.DeliveryModeActiveTab == 2) {
      if (orderData?.pageStep == 4) {
        return true;
      }
    } else if (orderData?.DeliveryModeActiveTab == 3) {
      return false;
    }
    return false;
  };

  /**
   * reload add my occassion data
   */
  useEffect(() => {
    if (AddToMyOccasionAddNewOpen == "refetch") {
      setAddToMyOccasionAddNewOpen(false);
      handelAddToMyOccasion();
    }
  }, [AddToMyOccasionAddNewOpen]);

  /**
   * repeat card quantity
   */
  useEffect(() => {
    switch (RepeatOrderOpen) {
      case "incQty":
        setRepeatOrderOpen(false);
        decrementCount(incrementQty?.id, incrementQty?.qty, "add");
        break;
      case "addNewProduct":
        setRepeatOrderOpen(false);
        setAddToCartOpen(true);
        break;
      default:
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [RepeatOrderOpen]);

  /**
   * checked cart quantity by checkbox
   */
  useEffect(() => {
    const allIds = props?.cartData?.map((item) => item?.id) || [];
    setCheckedCartItemId(allIds);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * if coupon applied
   */
  useEffect(() => {
    setCouponCode(orderData?.couponCode ? orderData?.couponCode : "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (orderData?.couponCode) {
      if (!isShowCouponCode()) {
        removeCouponCode();
      }
    }
  }, [orderData]);

  const ContentWrapper = ({ children }) => {
    if (isPopup) {
      return (
        <>
          <div 
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[9998]"
            onClick={onClose}
          />
          
          {/* Popup Container - Mobile Only */}
          <div className="fixed inset-0 z-[9999] flex items-end sm:items-center justify-center p-0 sm:p-4 pointer-events-none">
            <div 
              className="bg-[white] rounded-t-2xl sm:rounded-2xl w-full max-w-full sm:max-w-[400px] max-h-[90vh] overflow-y-auto pointer-events-auto shadow-2xl sm:mt-[60%]"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="sticky top-0 bg-[white] z-10 px-4 py-3 border-b border-gray-200 flex items-center justify-between">
                <Text className="text-black-900 font-semibold text-base">
                  Order Summary
                </Text>
                <button
                  onClick={onClose}
                  className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
                >
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 5L5 15M5 5L15 15" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
              {children}
            </div>
          </div>
        </>
      );
    }
    
    return (
      <div className="blick sm:hidden max-w-[400px] w-full sm:max-w-full bg-[#FFFFFF]">
        {children}
      </div>
    );
  };

  return (
    <>
      <ContentWrapper>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          
          {isReservationFlow ? (
            <>
              {!isPopup && (
                <div className="px-4 py-3 border-b border-gray-200">
                  <Text className="text-black-900 font-semibold text-base">
                    {t("reservationSummary")}
                  </Text>
                </div>
              )}

              <div className="p-4 flex flex-col gap-3">
                <div className="flex items-start gap-3">
                 
                  <div className="w-16 h-16 flex-shrink-0 bg-pink-50 rounded-lg flex items-center justify-center">
                    <Img src="/images/cake.png" alt="package" className="w-10 h-10 object-contain" />
                  </div>

                  <div className="flex-1 min-w-0">
                    <Text className={`text-[#1A1A1A] font-medium text-sm leading-5 ${headingClass}`}>
                      {reservationData?.packageName || "Reservation Package"}
                    </Text>
                    <Text className={`text-[#727783] text-sm font-normal leading-5 mt-0.5 ${interClass}`}>
                      {reservationData?.slotLabel} &bull; {reservationData?.guests} Guests
                    </Text>
                    {reservationData?.date && (
                      <Text className={`text-[#727783] text-xs mt-0.5 ${interClass}`}>
                        {new Date(reservationData.date).toLocaleDateString("en-SA", {
                          weekday: "short", month: "short", day: "numeric",
                        })}
                      </Text>
                    )}
                  </div>

                  <div className="flex items-center gap-1 flex-shrink-0">
                    <Img src="/images/Groupsar2.svg" alt="sar" className="w-[14px] h-[14px]" />
                    <Text className={`text-[#1A1A1A] font-medium text-base ${headingClass}`}>
                      {reservationData?.price}
                    </Text>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-lg p-3 grid grid-cols-2 gap-2">
                  {[
                    [<Img src="/images/clock.png" alt="sar" className="w-[24px] h-[24px]" />, `${reservationData?.hours} Hours`],
                    [<Img src="/images/person.png" alt="sar" className="w-[24px] h-[24px]" />, `Up to ${reservationData?.people} People`],
                    [<Img src="/images/chair.png" alt="sar" className="w-[24px] h-[24px]" />, `${reservationData?.chairs} Chairs`],
                    [<Img src="/images/cake.png" alt="sar" className="w-[24px] h-[24px]" />, `${reservationData?.cakes} Cakes`],
                  ].map(([icon, label]) => (
                    <div key={label} className="flex items-center gap-1">
                      <span className="text-sm">{icon}</span>
                      <Text className={`text-[#727783] text-xs ${interClass}`}>{label}</Text>
                    </div>
                  ))}
                </div>
              </div>

              {(() => {
                const rawPrice = Number(reservationData?.price) || 0;
                const basePrice = rawPrice / 1.15;
                const vatAmount = rawPrice - basePrice;
                const fmtBase = basePrice.toFixed(2);
                const fmtVat  = vatAmount.toFixed(2);
                const fmtTotal = rawPrice.toFixed(2);

                return (
                  <div className="px-4 py-4 border-t border-gray-200">
                    <Text className={`text-[black] ${interClass} text-lg font-medium leading-6 mb-3`}>
                      {t("orderSummary") || "Order Summary"}
                    </Text>

                    <div className="space-y-2">

                      <div className="flex justify-between text-sm">
                        <Text
                          className={`text-center ${interClass} text-base font-normal leading-6`}
                          style={{ color: "var(--Blacks-400, #727783)" }}
                        >
                          {t("packagePrice")}
                        </Text>
                        <div className="flex items-center gap-2">
                          <Img src="/images/Groupsar2.svg" alt="sar" className="w-[14px] h-[14px] object-contain" />
                          <Text
                            className={`${headingClass} text-base font-medium leading-6`}
                            style={{ color: "var(--Blacks-900, #1A1A1A)" }}
                          >
                            {t("sar")} {fmtBase}
                          </Text>
                        </div>
                      </div>

                      <div className="flex justify-between text-sm">
                        <Text
                          className={`text-center ${interClass} text-base font-normal leading-6`}
                          style={{ color: "var(--Blacks-400, #727783)" }}
                        >
                          {t("deliveryFee") || "Delivery Fee"}
                        </Text>
                        <div className="flex items-center gap-2">
                          <Img src="/images/Groupsar2.svg" alt="sar" className="w-[14px] h-[14px] object-contain" />
                          <Text
                            className={`${headingClass} text-base font-medium leading-6`}
                            style={{ color: "var(--Blacks-900, #1A1A1A)" }}
                          >
                            {t("sar")} 0.00
                          </Text>
                        </div>
                      </div>

                      <div className="flex justify-between text-sm">
                        <Text
                          className={`text-center ${interClass} text-base font-normal leading-6`}
                          style={{ color: "var(--Blacks-400, #727783)" }}
                        >
                          {t("taxVAT") || "Tax (VAT 15%)"}
                        </Text>
                        <div className="flex items-center gap-2">
                          <Img src="/images/Groupsar2.svg" alt="sar" className="w-[14px] h-[14px] object-contain" />
                          <Text
                            className={`${headingClass} text-base font-medium leading-6`}
                            style={{ color: "var(--Blacks-900, #1A1A1A)" }}
                          >
                            {t("sar")} {fmtVat}
                          </Text>
                        </div>
                      </div>

                    </div>

                    {/* Total */}
                    <div className="flex justify-between items-center mt-4 pt-3 border-t border-gray-300">
                      <Text className={`text-black-900 ${interClass} text-base`}>
                        {t("totalAmount") || "Total"}
                      </Text>
                      <div className="flex items-center gap-2">
                        <Img src="/images/Groupsar.svg" alt="sar" className="w-[14px] h-[14px] object-contain" />
                        <Text className={`text-[#771237] font-bold ${headingClass} text-lg`}>
                          {t("sar")} {fmtTotal}
                        </Text>
                      </div>
                    </div>
                  </div>
                );
              })()}

            </>
          ) : (
            <>
          {!isPopup && (
            <div className="px-4 py-3 border-b border-gray-200">
              <Text className="text-black-900 font-semibold text-base">
                {t("cartItems")} ({props?.cartData?.length || 0} {t("items")})
              </Text>
            </div>
          )}

          <div className="flex flex-col divide-y divide-gray-200">
            {props?.cartData.map((items, index) => {
              const totalPrice =
                Number(items?.productUom?.sellingPrice) +
                (items?.cartModifiers || []).reduce((acc, modifierItem) => {
                  const processedModifierIdsForQuantity = new Set();
                  return (
                    acc +
                    (modifierItem?.cartModifierItems || []).reduce(
                      (innerAcc, priceItem) => {
                        const modifierId = priceItem?.modifierItemId;
                        if (updatedModiferQuantity.length > 0) {
                          if (modifierId && !processedModifierIdsForQuantity.has(modifierId)) {
                            const matchedQty = updatedModiferQuantity?.find(
                              (q) => q.id === modifierId
                            );
                            const quantity = matchedQty?.quantity?.quantity;
                            innerAcc += Number(priceItem?.productUomModifierItem?.price || 0) * (quantity || 0);
                            processedModifierIdsForQuantity.add(modifierId);
                          }
                        } else {
                            innerAcc += Number(priceItem?.productUomModifierItem?.price || 0);
                        }
                        return innerAcc;
                      },
                      0
                    )
                  );
                }, 0);

              return (
                <div key={`cart-item-${index}`} className="p-4">
                  <div className="flex gap-3">
                    {/* Product Image */}
                    <div className="w-16 h-16 flex-shrink-0 bg-gray-100 rounded-lg overflow-hidden">
                      <img
                        src={
                          items?.productUom?.productUomImages?.find(img => img.featured === "1")?.image ||
                          items?.productUom?.productUomImages?.[0]?.image ||
                          "/images/placeholder.png"
                        }
                        alt={CUSTOM.getdataByLangKey(
                          items?.product?.productLocales,
                          "",
                          "name",
                          "10"
                        )}
                        className="w-full h-full object-cover"
                      />
                    </div>

                    {/* Product Details */}
                    <div className="flex-1 min-w-0">
                      {/* Product Name & Price */}
                      <div className="flex justify-between items-start mb-2">
                        <div className="flex-1 min-w-0 pr-2">
                          <Text
                            className={`text-[#1A1A1A] font-medium text-sm leading-5 ${headingClass} truncate`}
                          >
                            {CUSTOM.getdataByLangKey(
                              items?.product?.productLocales,
                              "",
                              "name",
                              "30"
                            )}
                          </Text>
                          <Text className={`text-[#727783] text-start ${interClass} text-sm font-normal leading-5 mt-0.5`}>
                            {items?.productUom?.name}
                            {items?.isCustomized}
                          </Text>
                        </div>
                        <div className="flex p-1">
                          <Img
                            className="h-3 w-3 object-cover w-[14px] h-[14px] py-[0.7px] justify-center items-center gap-[7px]"
                            src="/images/Groupsar2.svg"
                            alt="share"
                          />
                        </div>
                        <Text
                          className={`text-[#1A1A1A] text-center ${headingClass} text-base font-medium leading-6 whitespace-nowrap`}
                        >
                          {t("sar")} {CUSTOM.setPrice(totalPrice * items?.quantity)}
                        </Text>
                      </div>

                      <div className="flex items-center justify-between">
                       
                        {items?.isCustomized ? (
                          <button
                            onClick={() => {
                              setIncrementQty({
                                ...incrementQty,
                                product_id: items?.product?.id,
                                uomData: items,
                              });
                              setCustomiseOpen(true);
                            }}
                            className={`text-[#0088FF] text-center ${interClass} text-base font-normal leading-6 hover:underline`}
                          >
                           {t("editCustomization")}
                          </button>
                        ) : (
                          <div></div>
                        )}

                        <div className="flex items-center gap-2 border border-gray-300 rounded-[25px] px-2 py-1">
                          <button
                            onClick={() => {
                              CUSTOM.trackRemoveFromCart({
                                id: items?.productId,
                                name:
                                  items?.product?.slug +
                                  "-" +
                                  items?.productUom?.name,
                                quantity: items?.quantity,
                              });
                              decrementCount(
                                items?.id,
                                items?.quantity,
                                "subtract"
                              );
                            }}
                            className="w-6 h-6 flex items-center justify-center text-gray-600 hover:bg-gray-100 rounded"
                          >
                            <span className="text-base font-medium">−</span>
                          </button>
                          <span className={`text-[#1A1A1A] text-center ${interClass} text-sm font-medium leading-5 min-w-[20px]`}>
                            {items?.quantity}
                          </span>
                          <button
                            onClick={() => {
                              incrementCount(
                                items?.id,
                                items?.quantity,
                                items?.productId,
                                items
                              );
                            }}
                            className="w-6 h-6 flex items-center justify-center text-gray-600 hover:bg-gray-100 rounded"
                          >
                            <span className="text-base font-medium">+</span>
                          </button>
                        </div>
                      </div>

                      {/* Quantity Controls */}
                      {/* <div className="flex items-center gap-3 mt-2">
                        <div className="flex items-center border border-gray-300 rounded-md">
                          <button
                            onClick={() => {
                              CUSTOM.trackRemoveFromCart({
                                id: items?.productId,
                                name:
                                  items?.product?.slug +
                                  "-" +
                                  items?.productUom?.name,
                                quantity: items?.quantity,
                              });
                              decrementCount(
                                items?.id,
                                items?.quantity,
                                "subtract"
                              );
                            }}
                            className="px-3 py-1.5 hover:bg-gray-50 transition-colors"
                          >
                            <span className="text-lg leading-none">−</span>
                          </button>
                          <span className="px-3 py-1.5 text-sm font-medium border-x border-gray-300 min-w-[40px] text-center">
                            {items?.quantity}
                          </span>
                          <button
                            onClick={() => {
                              incrementCount(
                                items?.id,
                                items?.quantity,
                                items?.productId,
                                items
                              );
                            }}
                            className="px-3 py-1.5 hover:bg-gray-50 transition-colors"
                          >
                            <span className="text-lg leading-none">+</span>
                          </button>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Do you have any note section */}
          <div className="px-4 py-3 border-t border-gray-200">
            <textarea
              type="text"
              placeholder={t("anyNote?WriteHere") || "Do you have any note? Write here..."}
              value={orderData?.notes}
              onChange={(e) => {
                dispatch(
                  updateOrderData({
                    ...orderData,
                    notes: CUSTOM.strFormat(e.target.value, "max:250"),
                  })
                );
              }}
              className="w-full border border-gray-300 rounded-md p-2 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows="2"
            />
          </div>

          {/* Coupon Code Section */}
          {auth?.id && (
            <div className="px-4 py-3 border-t border-gray-200">
              {/* {!orderData?.couponCode && isShowCouponCode() ? ( */}
              <div className="flex items-center border border-gray-300 rounded-full px-2 py-1">
                
                {/* Coupon Icon + Input */}
                <div className="flex items-center flex-1 gap-2 px-2">
                  <span className="text-pink-600 text-sm">
                    <Img
                      className="h-5 w-5 object-cover"
                      src="/images/discountIcon.svg"
                      alt="share"
                    /> </span>
                  <input
                    type="text"
                    placeholder={t("enterCouponCode")}
                    value={couponCode}
                    onChange={(e) => {
                      setCouponCodeError("");
                      setCouponCode(CUSTOM.strFormat(e.target.value, "max:30"));
                    }}
                    className={`w-full border-0 bg-transparent text-left ${interClass} text-sm font-normal leading-5 text-[#A2A6AE] placeholder:text-[#A2A6AE] focus:outline-none`}
                  />
                </div>

                {/* Apply Button */}
                <button
                  onClick={() => {
                    setCouponCodeError("");
                    if (couponCode) {
                      applyCouponCode();
                    }
                  }}
                  className={`bg-[#7b1736] text-[white] px-5 py-2 ${interClass} rounded-full text-sm font-medium hover:opacity-90 transition whitespace-nowrap`}
                >
                  {t("apply")}
                </button>
              </div>
              {/* ) : null} */}
            </div>
          )}

          {/* Order Summary */}
          <div className="px-4 py-4 border-t border-gray-200">
            <Text className={`text-[black] ${interClass} text-lg font-medium leading-6 mb-3`}>
              {t("orderSummary") || "Order Summary"}
            </Text>

            <div className="space-y-2">
              {/* Subtotal */}
              <div className="flex justify-between text-sm">
                <Text
                  className={`text-center ${interClass} text-base font-normal leading-6`}
                  style={{ color: "var(--Blacks-400, #727783)" }}
                >
                  {t("productsubtotal")}
                </Text>
                <div className="flex items-center gap-2">
                  <Img
                    src="/images/Groupsar2.svg"
                    alt="sar"
                    className="w-[14px] h-[14px] object-contain"
                  />

                  <Text
                    className={`${headingClass} text-base font-medium leading-6`}
                    style={{ color: "var(--Blacks-900, #1A1A1A)" }}
                  >
                    {t("sar")} {CUSTOM.setPrice(orderSummary?.sub_total)}
                  </Text>
                </div>
              </div>

              {/* Delivery Fee */}
              {orderSummary?.delivery_fees ? (
                <div className="flex justify-between text-sm">
                  <Text className={`text-center ${interClass} text-base font-normal leading-6`}
                  style={{ color: "var(--Blacks-400, #727783)" }}>{t("deliveryFee") || "Delivery Fee"}</Text>
                  <div className="flex items-center gap-2">
                    <Img
                      src="/images/Groupsar2.svg"
                      alt="sar"
                      className="w-[14px] h-[14px] object-contain"
                    />
                    <Text
                      className={`text-center ${headingClass} text-base font-medium leading-6`}
                      style={{ color: "var(--Blacks-900, #1A1A1A)" }}
                    >
                      {t("sar")} {CUSTOM.setPrice(orderSummary?.delivery_fees)}
                    </Text>
                  </div>
                </div>
              ) : null}

              {/* Tax VAT */}
              {orderSummary?.vat ? (
                <div className="flex justify-between text-sm">
                  <Text className={`text-center ${interClass} text-base font-normal leading-6`}
                  style={{ color: "var(--Blacks-400, #727783)" }}>{t("taxVAT")}</Text>
                  <div className="flex items-center gap-2">
                    <Img
                      src="/images/Groupsar2.svg"
                      alt="sar"
                      className="w-[14px] h-[14px] object-contain"
                    />
                    <Text
                      className={`text-center ${headingClass} text-base font-medium leading-6`}
                      style={{ color: "var(--Blacks-900, #1A1A1A)" }}
                    >
                      {t("sar")} {CUSTOM.setPrice(orderSummary?.vat)}
                    </Text>
                  </div>
                </div>
              ) : null}

              {/* Coupon Discount */}
              {orderSummary?.coupon_discount ? (
                <div className="flex justify-between text-sm">
                  <Text className="text-gray-700">
                    {t("couponDiscount") || "Coupon Discount"}
                  </Text>
                  <div className="flex items-center gap-2">
                  <Img
                    src="/images/Groupsar2.svg"
                    alt="sar"
                    className="w-[14px] h-[14px] object-contain"
                  />
                  <Text className="text-green-600 font-medium">
                    - {t("sar")} {CUSTOM.setPrice(orderSummary?.coupon_discount)}
                  </Text>
                  </div>
                </div>
              ) : null}

              {/* Timeslot Discount */}
              {orderSummary?.timeslot_discount ? (
                <div className="flex justify-between text-sm">
                  <Text className="text-gray-700">Timeslot Discount</Text>
                  <Text className="text-green-600 font-medium">
                    - {t("sar")} {CUSTOM.setPrice(orderSummary?.timeslot_discount)}
                  </Text>
                </div>
              ) : null}
            </div>

            {/* Total */}
            <div className="flex justify-between items-center mt-4 pt-3 border-t border-gray-300">
              <Text className={`text-black-900 ${interClass} font-[18px] text-base`}>
                {t("totalAmount") || "Total"}
              </Text>
              <div className="flex items-center gap-2">
                  <Img
                    src="/images/Groupsar.svg"
                    alt="sar"
                    className="w-[14px] h-[14px] object-contain"
                  />
                <Text className={`text-[#771237] font-bold ${headingClass} text-lg`}>
                  {t("sar")} {CUSTOM.setPrice(orderSummary?.total_amount)}
                </Text>
              </div>
            </div>
          </div>
            </>
          )}
        </div>
      </ContentWrapper>

      {/* OLD CODE - COMMENTED FOR REFERENCE */}
      {/* 
      <div className="max-w-[350px] w-full sm:pl-0 xs:pl-0 sm:max-w-full sm:order-1">
        <div className="bg-white-A700 w-full">
          <div className="px-2 py-1 flex flex-row items-center justify-between border-b border-gray-300 w-full">
            <div className="w-auto flex flex-row items-center gap-0.5">
              <Img
                className="h-10 object-contain w-10 min-w-[1.5rem]"
                src="/images/state-layer-unselect.svg"
                alt="rabbitholelogo"
              />
              <Text className="text-black-900 whitespace-nowrap font-medium font-nunitomedium text-sm leading-6 mb-1">
                {checkedCartItemId.length}/{props?.cartData.length}
              </Text>
            </div>
            <div className="w-auto pr-3">
              {auth?.id != 0 && checkedCartItemId.length != 0 ? (
                <Text
                  className="cursor-pointer text-pink-800 whitespace-nowrap font-medium font-nunitomedium text-sm leading-6 mb-1"
                  onClick={handelAddToMyOccasion}
                >
                  {t("moveToOccasion")}
                </Text>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      */}

      {/* Popups - Kept as is */}
      {AddToCartOpen === true ? (
        <AddToCart
          closepopup={setAddToCartOpen}
          productId={incrementQty?.product_id}
          productName={incrementQty?.productName}
          price={incrementQty?.price}
          quantity={incrementQty?.quantity}
        />
      ) : null}

      {customizeOpen === true ? (
        <AddToCart
          closepopup={setCustomiseOpen}
          productId={incrementQty?.product_id}
          customizeItem={incrementQty}
          productName={incrementQty?.productName}
          price={incrementQty?.price}
          quantity={incrementQty?.quantity}
          onCartChange={(updated) =>
            setUpdatedModiferQuantity(Object.values(updated))
          }
        />
      ) : null}

      {RepeatOrderOpen === true ? (
        <RepeatOrder
          closepopup={setRepeatOrderOpen}
          cartIds={incrementQty}
          cartData={props?.cartData}
        />
      ) : null}

      {AddToMyOccasionOpen === true ? (
        <AddToMyOccasion
          closepopup={setAddToMyOccasionOpen}
          setNewOccasion={handelAddToMyOccasionAddNew}
          moveToOccasion={checkedCartItemId}
        />
      ) : null}
      {AddToMyOccasionAddNewOpen === true ? (
        <AddToMyOccasionAddNew
          closepopup={setAddToMyOccasionAddNewOpen}
          modalTopIcon="/images/add_to-occasion-icon.svg"
          OccasionTitle={t("addNewOccasion")}
          OccasionParagraph={t("enterBelowDetailsToAddANewOccasionDot")}
        />
      ) : null}
    </>
  );
};

export default CartProductDetail;